import moment from 'moment';

export function ReceiptTimeFilter() {
    'ngInject';
    return function(estimatedFulfillment, submittedTime) {
        if (undefined === estimatedFulfillment) {
            return '';
        }
        let initial = moment(submittedTime);
        let tomorrow = moment(initial);
        tomorrow.add(1, 'days');
        let displayMoment = moment(estimatedFulfillment);
        displayMoment.startOf('minute');

        let timeString = displayMoment.format('h:mm a');
        let dateString = displayMoment.format('MMMM D, YYYY');

        if (displayMoment.isSame(initial, 'day')) {
            return timeString;
        } else if (displayMoment.isSame(tomorrow, 'day')) {
            return `${timeString} tomorrow, ${dateString}`;
        } else {
            return `${timeString}, ${dateString}`;
        }
    };
}
